var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "max-width": "960",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "채팅상담 프롬프트 설정"
    }
  }), _c('v-data-table', _vm._b({
    ref: "data-table",
    staticClass: "v-sheet--outlined",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function () {
        return [_c('prompt-list-groups'), _vm._v(" "), _c('v-divider')];
      },
      proxy: true
    }, {
      key: "body",
      fn: function (props) {
        return [_vm.$refs['data-table'] ? _c('draggable', {
          attrs: {
            "tag": "tbody",
            "list": props.items,
            "disabled": !_vm.group || _vm.loading
          },
          on: {
            "change": _vm.setNewIndex
          }
        }, [_c('v-nodes', {
          attrs: {
            "vnodes": _vm.$refs['data-table'].genItems(props.items, props)
          }
        })], 1) : _vm._e()];
      }
    }, _vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.thumb`,
      fn: function (_ref2) {
        var value = _ref2.value;
        return [_c('image-popup', {
          attrs: {
            "size": "40",
            "src": value === null || value === void 0 ? void 0 : value.url
          }
        })];
      }
    }, {
      key: `item.photo`,
      fn: function (_ref3) {
        var value = _ref3.value;
        return [_c('image-popup', {
          attrs: {
            "size": "40",
            "src": value === null || value === void 0 ? void 0 : value.url
          }
        })];
      }
    }, {
      key: `item.prompt`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('vertical-table-row', _vm._b({
          attrs: {
            "term": "질문",
            "divider": ""
          }
        }, 'vertical-table-row', _vm.attrs_verticalTable, false), [_c('prompt-list-query-edit', _vm._g({
          attrs: {
            "value": item
          }
        }, {
          update: _vm.update
        }), [_vm._v(" " + _vm._s(item.query || "-") + " ")])], 1), _c('vertical-table-row', _vm._b({
          attrs: {
            "term": "답변",
            "divider": "",
            "hideDivider": ""
          }
        }, 'vertical-table-row', _vm.attrs_verticalTable, false), [_c('prompt-list-reply-edit', _vm._g({
          attrs: {
            "value": item
          }
        }, {
          update: _vm.update
        }), [_vm._v(" " + _vm._s(item.reply || "-") + " ")])], 1)];
      }
    }, {
      key: `item.isEnabled`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('v-switch', _vm._b({
          on: {
            "change": function (isEnabled) {
              return _vm.update({
                _id: item._id,
                isEnabled
              });
            }
          },
          model: {
            value: item.isEnabled,
            callback: function ($$v) {
              _vm.$set(item, "isEnabled", $$v);
            },
            expression: "item.isEnabled"
          }
        }, 'v-switch', _vm.attrs_switch__console, false))];
      }
    }, {
      key: `item.actions`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_c('prompt-item-form', {
          attrs: {
            "_id": item._id
          },
          on: {
            "input": _vm.updateItem
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref7) {
              var attrs = _ref7.attrs,
                on = _ref7.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "small": "",
                  "text": "",
                  "icon": "",
                  "tile": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v(" mdi-pencil ")])], 1)];
            }
          }], null, true)
        }), _c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "icon": "",
            "tile": ""
          },
          on: {
            "click": function ($event) {
              return _vm.remove(item);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-delete ")])], 1)];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('v-divider'), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-spacer'), _c('v-divider', {
          attrs: {
            "vertical": ""
          }
        }), _c('prompt-item-form', _vm._b({
          on: {
            "input": _vm.updateItem
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref8) {
              var attrs = _ref8.attrs,
                on = _ref8.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "text": "",
                  "tile": "",
                  "color": "primary",
                  "height": "48"
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                staticClass: "mr-1",
                attrs: {
                  "small": ""
                }
              }, [_vm._v(" mdi-plus ")]), _vm._v(" 항목추가하기 ")], 1)];
            }
          }])
        }, 'prompt-item-form', {
          group: _vm.group
        }, false))], 1)];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    loading: _vm.loading,
    headers: _vm.headers,
    items: _vm.items
  }, false)), _c('v-pagination', {
    staticClass: "mt-2",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }